import { useDYUserStore } from "~~/modules/nuxt3-module-doyac/stores/user"

export default defineNuxtPlugin(async ({ $pinia }) => {
  const headers = useRequestHeaders()
  const { injectBrowserInfo } = useDYUserStore($pinia)

  injectBrowserInfo()
})